var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// @flow
// @ts-nocheck
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { palette } from '@shared/utils/styled';
import Icon from '@shared/atoms/Icon';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  colort: ", ";\n  height: 2rem;\n  margin-top: 1.5625rem;\n"], ["\n  display: inline-block;\n  colort: ", ";\n  height: 2rem;\n  margin-top: 1.5625rem;\n"])), palette('text'));
var GoBack = /** @class */ (function (_super) {
    __extends(GoBack, _super);
    function GoBack() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GoBack.prototype.render = function () {
        var history = this.props.history;
        return (_jsx(Wrapper, __assign({ onClick: history.goBack }, { children: _jsx(Icon, { icon: 'iconBack', width: 23 }, void 0) }), void 0));
    };
    return GoBack;
}(Component));
export default withRouter(GoBack);
var templateObject_1;
